export const FETCH_SETTING = {
    REQUEST: 'DELIVERY_NOTE_PRINT.FETCH_SETTING.REQUEST',
    SUCCESS: 'DELIVERY_NOTE_PRINT.FETCH_SETTING.SUCCESS',
    FAILED: 'DELIVERY_NOTE_PRINT.FETCH_SETTING.FAILED',
};

export const CLEAR_STATE = "DELIVERY_NOTE_PRINT.CLEAR_STATE";